import {Button, Stack, useTheme} from '@mui/material';
import React from 'react';
import {Content, TooltipContainer} from './styles';
import type {TooltipTutorialProps} from './types';

export function Tooltip({
	step,
	primaryProps,
	backProps,
	skipProps,
	customContainerWidth,
	secondaryLabel,
}: TooltipTutorialProps) {
	const theme = useTheme();

	const {hideBackButton} = step;
	const showSecondaryAction = Boolean(secondaryLabel);

	return (
		<TooltipContainer $customWidth={customContainerWidth}>
			<Content>{step.content}</Content>

			<Stack direction="row" justifyContent="flex-end" spacing={1} width="100%">
				{showSecondaryAction ? (
					<Button variant="text" {...skipProps} sx={{color: 'text.secondary'}}>
						{secondaryLabel ?? skipProps.title}
					</Button>
				) : null}

				{!hideBackButton && backProps ? (
					<Button
						variant="text"
						{...backProps}
						sx={{color: theme.palette.primary.main}}
					/>
				) : null}

				{primaryProps ? (
					<Button
						variant="text"
						{...primaryProps}
						sx={{color: theme.palette.primary.main}}
					/>
				) : null}
			</Stack>
		</TooltipContainer>
	);
}
